import { useCallback } from 'react';
import { useFileUpload } from './use-file-upload';
import { useLayoutId } from './use-layout-id';
import { useProjectId } from './use-project-id';
import { useAddLayoutFilesMutation } from '../api';
/**
 * Hook to upload a file and add it to a layout
 *
 * @returns an upload function
 */
export const useLayoutFileUpload = () => {
    const projectId = useProjectId();
    const layoutId = useLayoutId();
    const { upload: uploadFile } = useFileUpload();
    const [addLayoutFile] = useAddLayoutFilesMutation();
    const upload = useCallback(async (files, onProgress) => {
        const uploadedFileIds = [];
        for (const file of files) {
            const uploadedFile = await uploadFile(file, projectId, onProgress);
            uploadedFileIds.push(uploadedFile.id);
        }
        const data = { file_ids: uploadedFileIds };
        return await addLayoutFile({ projectId, layoutId, data: data }).unwrap();
    }, [projectId, uploadFile, addLayoutFile, layoutId]);
    return {
        upload,
    };
};
